<template>
  <nav class="navbar navbar-expand-xl navbar-light bg-white shadow-sm sticky-top">
    <div class="container">
      <a href="#top" class="navbar-brand d-flex align-items-center">
        <div class="d-inline-flex align-items-center justify-content-center backgroundmain text-white rounded mr-2 t1-icon-badge">
          <i class="bi bi-wrench"></i>
        </div>
        <div class="d-flex flex-column lh-1">
          <strong>{{ company.name }}</strong>
          <small class="text-muted text-uppercase t1-navbar-tagline">{{ company.tagline }}</small>
        </div>
      </a>

      <button
        class="navbar-toggler border-0"
        type="button"
        :aria-expanded="open ? 'true' : 'false'"
        aria-label="Toggle menu"
        @click="open = !open"
      >
        <i class="bi" :class="open ? 'bi-x-lg' : 'bi-list'" style="font-size: 1.5rem;"></i>
      </button>

      <div class="collapse navbar-collapse" :class="{ show: open }">
        <ul class="navbar-nav mx-xl-auto">
          <li class="nav-item" v-for="link in links" :key="link.href">
            <a class="nav-link" :href="link.href" @click="open = false">{{ link.label }}</a>
          </li>
        </ul>

        <div class="d-none d-xl-flex align-items-center">
          <a v-for="c in contactLinks" :key="c.icon" :href="c.href" class="nav-link font-weight-bold text-dark">
            <i :class="['bi', c.icon, 'textmain', 'mr-1']"></i>{{ c.text }}
          </a>
        </div>
      </div>
    </div>

    <div class="w-100 d-flex d-xl-none justify-content-center t1-navbar-contact-mobile">
      <a v-for="c in contactLinks" :key="c.icon" :href="c.href" class="nav-link font-weight-bold text-dark">
        <i :class="['bi', c.icon, 'textmain', 'mr-1']"></i>{{ c.text }}
      </a>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Theme1NavBar',
  props: {
    company: { type: Object },
    links: {
      type: Array,
      default: () => [
        { label: 'Services', href: '#services' },
        { label: 'Why Us', href: '#why-us' },
        { label: 'Service Area', href: '#service-area' },
        { label: 'Contact', href: '#quote' },
      ],
    },
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    contactLinks() {
      return [
        { href: `tel:${this.company.phoneHref}`, icon: 'bi-telephone-fill', text: this.company.phone },
        { href: `mailto:${this.company.email}`, icon: 'bi-envelope-fill', text: this.company.email },
      ];
    },
  },
};
</script>
